export const pagesProductsEn = {
  add: {
    backButton: 'Back',
    documentTitle: 'Add Product',
    fields: {
      code: 'Code',
      name: 'Name',
      objective: 'Objective',
      owner: 'Owner',
      publishScope: 'Publish Scope',
      publishStatus: 'Publish Status',
    },
    nextButton: 'Next',
    pageTitle: 'Add Product',
    placeholders: {
      code: 'e.g. PRD-001',
      name: 'e.g. Atlas',
      objective: 'What problem does this product solve?',
      owner: 'Select an owner',
    },
    progressbar: {
      filled: 'Filled',
      modeSetting: 'Input Mode',
      mustItem: 'Required Items',
      mustItemOnly: 'Required fields only',
      progressCircle: 'Progress Circle',
      title: 'Progress',
      total: 'All Items',
    },
    sections: {
      basicInfo: 'Basic Information',
      owner: 'Owner',
      publishSettings: 'Publish Settings',
    },
    stepper: {
      basicInfo: 'Basic Information',
      owner: 'Owner',
      publishSettings: 'Publish Settings',
      title: 'Sections',
    },
    submitButton: 'Create',
    toast: {
      error: 'Failed to create product',
      success: 'Product created',
    },
    validation: {
      required: 'Required',
    },
  },
  addSelect: {
    csvBulkUpload: 'Bulk upload via CSV',
    externalSystemSync: 'Sync with external system',
    fillOutDetails: 'Fill out details',
    methods: {
      csv: {
        inDevelopmentTag: 'In Development',
      },
      externalSystemSync: {
        inDevelopmentTag: 'In Development',
      },
    },
    orLabel: 'Or...',
    pageTitle: 'Add Product',
    productCardTitle: 'Product',
    requiredFields: {
      name: 'Name',
      objective: 'Objective',
      publishScope: 'Publish Scope',
    },
    requiredItems: 'Required items',
    selectionTitle: 'How would you like to add the product?',
  },
  detail: {
    breadcrumb: {
      home: 'Home',
      products: 'Products',
    },
    fields: {
      dependencies: 'Dependencies',
      featureFlag: 'Feature Flag',
      firstReleaseDate: 'First Release Date',
      id: 'ID',
      name: 'Name',
      objective: 'Objective',
      owner: 'Owner',
      publishScope: 'Publish Scope',
      status: 'Status',
      type: 'Type',
      updateCount: 'Update Count',
      updatedAt: 'Last Updated',
    },
    header: {
      labels: {
        firstRelease: 'First Release',
        latestRelease: 'Latest Release',
        updateCount: 'Updates: {{count}}',
        updatedAt: 'Updated: {{date}}',
      },
      ownerNotSet: 'Owner not set',
    },
    kind: {
      FUNCTION: 'Function',
      MODULE: 'Module',
      PRODUCT: 'Product',
      SUB_MODULE: 'Sub-module',
    },
    pageTitle: 'Product Details',
    productScope: {
      noResults: "No features are included in this product's scope.",
      table: {
        headers: {
          kind: 'Type',
          name: 'Name',
          publishStatus: 'Publish Status',
        },
        kind: {
          FUNCTION: 'Function',
          MODULE: 'Module',
          PRODUCT: 'Product',
          SPECIFICATION: 'Specification',
          SUB_MODULE: 'Sub Module',
        },
      },
    },
    realizingValue: {
      noResults: 'No values are realized by this feature.',
      table: {
        headers: {
          code: 'No.',
          confidence: 'Confidence',
          layer: 'Layer',
          status: 'Status',
          targetBusiness: 'Business',
          targetUser: 'User',
          title: 'Title',
        },
        layer: {
          COMPANY_WIDE: 'Company-wide',
          EXECUTIVE: 'Executive',
          MANAGER: 'Manager',
          OPERATOR: 'Operator',
        },
      },
    },
    subSections: {
      basicInfo: 'Basic Info',
    },
    tabs: {
      detail: 'Detail',
      history: 'History',
      productScope: 'Product Scope',
      value: 'Realizing Values',
    },
    topSections: {
      basicInfo: 'Basic Info',
    },
    updateCountFormat: '{{count}} times',
  },
  list: {
    addProduct: 'Add Product',
    filterPlaceholder: 'Search products...',
    noResults: 'No matching products found.',
    pageTitle: 'Products',
    publishScope: {
      internal: 'Internal Only',
      none: 'Private',
      public: 'Public',
      restricted: 'Restricted',
    },
    publishStatus: {
      published: 'Published',
      unpublished: 'Unpublished',
    },
    table: {
      headers: {
        firstReleaseName: 'First Release',
        firstReleasedAt: 'First Released On',
        latestReleaseName: 'Latest Release',
        latestReleasedAt: 'Latest Released On',
        name: 'Name',
        publishScope: 'Publish Scope',
        publishStatus: 'Publish Status',
      },
    },
    tabs: {
      all: 'All',
      unpublished: 'Unpublished',
    },
  },
  title: 'Products',
};
